import { EDI_RFID_AUDIT_EXECUTION_DELETE_REQUEST, EDI_RFID_AUDIT_EXECUTION_DELETE_SUCCESS, EDI_RFID_AUDIT_EXECUTION_DELETE_FAILURE } from './types/EdiRfidAuditExecutionDeleteActionsTypes';

export function deleteEdiRfidAuditExecutionRequestActionCreator(selectedExecutionIds) {
  return {
    type: EDI_RFID_AUDIT_EXECUTION_DELETE_REQUEST,
    payload: {
      params: {
        executionIds: selectedExecutionIds,
      },
    },
  };
}

export function deleteEdiRfidAuditExecutionSuccessActionCreator(data) {
  return {
    type: EDI_RFID_AUDIT_EXECUTION_DELETE_SUCCESS,
    payload: data,
  };
}

export function deleteEdiRfidAuditExecutionFailureActionCreator(error) {
  return {
    type: EDI_RFID_AUDIT_EXECUTION_DELETE_FAILURE,
    payload: error,
    error: true,
  };
}
